import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import authData from "../../services/authData";
import { axiosVal as axios, getToken } from "..";

const initialState = {
    loaded: false,
    isLoggedin: false,
    logout: false,
    progress: false,
    isAuthenticated: false,
    resetModalStatus: false,
    changeWorkingType: false,
    accountWorkingTypeUpdated: false,
    user: {
        
    },
    userAccount: {
        
    },
    searchResults: [],
    accountUpdated: false,
    accountDeleted: false,
    error: {
        status: false,
        message: ""
    },
    success: {
        status: false,
        message: ""
    },
    emailVerSeucces: {
        status: false,
        message: ""
    },
    emailVerError: {
        status: false,
        message: ""
    },
    resetEmailError: {
        status: false,
        message: ""
    },
    resetEmailSuccess: {
        status: false,
        message: ""
    },
    updatePasswordError: {
        status: false,
        message: ""
    },
    updatePasswordSuccess: {
        status: false,
        message: ""
    }
};



export const searchUsers = createAsyncThunk('users/search', async(searchValue) => {
   
    try {
        const response = await axios.get(
            "/users/search",
            {
                params: { name: searchValue },
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
       
        return response.data;
    }
    catch(error) {
        throw error.response.data;
    }
})

export const Login = createAsyncThunk('users/login', async(userData) => {
    try {
        const response = await axios.post(
            "/users/login",
            {...userData}
        );
        
        return response;
    }
    catch(error) {
        throw Error(error.response?.data.message) ;
    }
})

export const Logout = createAsyncThunk('users/logout', async() => {
    try {
        
        const response = await axios.delete(
            "/users/logout",
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
       
        return response;
    }
    catch(error) {
        throw error.response.data;
    }
})

export const Me = createAsyncThunk('users/me', async() => {
    const response = await axios.get(
        "/users/me",
        {
            headers: {
                'x-auth': getToken(),
            },
        }
    );
    return response?.data;
});

export const getUserById = createAsyncThunk('users/byId', async(id) => {

    const response = await axios.get(
        `/users/${id}`,
        {
            headers: {
                'x-auth': getToken(),
            },
        }
    );
    return response?.data;
});

export const Register = createAsyncThunk('users/register', async(userData) => {
    try {
        const response = await axios.post(
            "/users/register",
            {...userData},
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return response?.data;
    }
    catch(error) {
        throw Error(error.response?.data.message) ;
    }
});

export const EmailVerificationAction = createAsyncThunk('users/emailVerification', async(token) => {
    try {
        const response = await axios.post(
            "/users/emailVerification",
            {token}
        );
        return response?.data;
    }
    catch(error) {
       throw Error(error.response?.data.message) ;
    }
})

export const SendResetPasswordEmail = createAsyncThunk('users/SendResetPasswordEmail', async(email) => {
    try {
        const response = await axios.post(
            "/users/SendResetPasswordEmail",
            {email}
        );
        return response?.data;
    }
    catch(error) {
       throw Error(error.response?.data.message) ;
    }
})

export const UpdatePassword = createAsyncThunk('users/UpdatePassword', async({password, token}) => {
    try {
        const response = await axios.post(
            "/users/UpdatePassword",
            {password, token}
        );
        return response?.data;
    }
    catch(error) {
       throw Error(error.response?.data.message) ;
    }
})

export const UpdateAccount = createAsyncThunk('users/updateAccount', async(userData) => {

    const response = await axios.put(
        "/users/account",
        {...userData},
        {
            headers: {
                'x-auth': getToken(),
            },
        }
    );
    return response?.data;
});

export const ImageUpload = createAsyncThunk(
    'users/imageUpload',
    async (formData, { rejectWithValue }) => {
      try {
        const response = await axios.post(
          '/users/imageUpload',
          formData,  // Send FormData directly
          {
            headers: {
              'x-auth': getToken(),
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
);


export const UpdateUserWorkingType = createAsyncThunk(
    'users/UpdateUserWorkingType',
    async (formData, { rejectWithValue }) => {
      try {
        const response = await axios.put(
          '/users/'+formData['userId']+'/workingType',
          formData,  // Send FormData directly
          {
            headers: {
              'x-auth': getToken()
            }
          }
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
);

export const UpdateEmployeeAccount = createAsyncThunk('users/updateEmployeeAccount', async({id, userData}) => {

    const response = await axios.put(
        `/users/${id}/account`,
        {...userData},
        {
            headers: {
                'x-auth': getToken(),
            },
        }
    );
    return response?.data;
});

export const UpdateAccountPasword = createAsyncThunk('users/UpdateAccountPasword', async(userData) => {

    const response = await axios.patch(
        `/users/account`,
        {...userData},
        {
            headers: {
                'x-auth': getToken(),
            },
        }
    );
    return response?.data;
});

export const UpdateEmployeeAccountPasword = createAsyncThunk('users/UpdateEmployeeAccountPasword', async({userData, id}) => {

    const response = await axios.patch(
        `/users/${id}/account`,
        {...userData},
        {
            headers: {
                'x-auth': getToken(),
            },
        }
    );
    return response?.data;
});

export const DeleteUserById = createAsyncThunk('users/deleteUserById', async (id) => {
    const response = await axios.delete(
        `/users/delete/${id}`,
        {
            headers: {
                'x-auth': getToken(),
            },
        }
    );

    return response?.data;
});

export const googleSignIn = createAsyncThunk('users/googleSignIn', async (user) => {
    try {
        const response = await axios.post(
            `/users/googleSignIn`,
            {
                ...user   
            }
        );
    
        return response;
    }
    catch(error) {
        throw new Error(JSON.stringify(error.response.data));
    }
});

const usersSlice = createSlice({
    name: "counter",
    initialState,
    reducers: {
        reset(state, action) {
            state.error.status = false;
            state.success.status = false;
            state.accountUpdated = false;
            state.accountDeleted = false;
            state.accountWorkingTypeUpdated = false;
            state.emailVerError.status = false;
            state.emailVerSeucces.status = false;
            state.resetEmailError.status = false;
            state.resetEmailSuccess.status = false;
            // return initialState;
        },
        updateUser(state, action) {
            state.loaded = true;
            const {payload} = action;
            if (payload.user) {
                state.user = payload.user;
            }
            state.isLoggedin = payload.isLoggedin;
            if (payload.accessToken) {
                // authData.set(payload.accessToken, true)
            }
        },
        updateResetModalStatus(state, action) {
            state.resetModalStatus = action.payload;
        },
        closeResetModal(state, action) {
            state.resetModalStatus = false;
        },
        updateWorkingTypeModalStatus(state, action) {
            state.changeWorkingType = action.payload;
        },
        closeWorkingTypeModalStatus(state, action) {
            state.changeWorkingType = false;
        }
    },
    extraReducers: (builder) => {

        builder.addCase(getUserById.fulfilled, (state, action) => {
            state.loaded = true;
            state.userAccount = action?.payload;
        })
        builder.addCase(UpdateEmployeeAccount.fulfilled, (state, action) => {
            state.loaded = true;
            state.userAccount = action?.payload;
            state.accountUpdated = true;
        })
        builder.addCase(UpdateEmployeeAccountPasword.fulfilled, (state, action) => {
            state.loaded = true;
            state.userAccount = action?.payload;
            state.resetModalStatus = false;
        })
        builder.addCase(Me.fulfilled, (state, action) => {
            state.loaded = true;
            state.user = action?.payload;
            state.isAuthenticated = true;
        })
        builder.addCase(Me.rejected, (state, action) => {
            state.loaded = true;
            state.isAuthenticated = false;
        })
        builder.addCase(EmailVerificationAction.pending, (state, action) => {
            state.emailVerSeucces.status = false;
        })
        builder.addCase(SendResetPasswordEmail.rejected, (state, action) => {
            state.resetEmailError.status = true;
            state.resetEmailError.message = action.error.message;
        })
        builder.addCase(SendResetPasswordEmail.pending, (state, action) => {
            state.resetEmailError.status = false;
            state.resetEmailSuccess.status = false;
        })
        builder.addCase(SendResetPasswordEmail.fulfilled, (state, action) => {
            state.resetEmailSuccess.status = true;
            state.resetEmailSuccess.message = action.payload.success;
        })
        builder.addCase(UpdatePassword.rejected, (state, action) => {
            state.updatePasswordError.status = true;
            state.updatePasswordSuccess.message = false;
        })
        builder.addCase(UpdatePassword.pending, (state, action) => {
            state.updatePasswordError.status = false;
            state.updatePasswordSuccess.message = false;
        })
        builder.addCase(UpdatePassword.fulfilled, (state, action) => {
            console.log("ccccccccccccccccccccc", action.payload.success)
            state.updatePasswordError.status = false;
            state.updatePasswordSuccess.status = true;
            state.updatePasswordSuccess.message = "succcess_reset_password";
        })
        builder.addCase(EmailVerificationAction.fulfilled, (state, action) => {
            state.emailVerError.status = false;
            state.emailVerSeucces.status = true;
            state.emailVerSeucces.message = action.payload.success;
        })
        builder.addCase(EmailVerificationAction.rejected, (state, action) => {
            state.emailVerSeucces.status = false;
            state.emailVerError.status = true;
            state.emailVerError.message = "invalid_token";
        })
        builder.addCase(Register.fulfilled, (state, action) => {
            state.loaded = true;
            state.progress = false;
            state.success.status = true;
            state.success.message = action.payload.message;
        })
        builder.addCase(Register.rejected, (state, action) => {
            state.loaded = true;
            state.progress = false;
            state.error.status = true;
            state.error.message = action.error.message;
        })
        builder.addCase(Register.pending, (state, action) => {
            state.loaded = true;
            state.progress = true;
            state.error.status = false;
            state.success.status = false;
        })
        builder.addCase(Login.pending, (state, action) => {
            state.progress = true;
            state.error.status = false;
            state.success.status = false;
        })
        builder.addCase(Login.fulfilled, (state, action) => {
            state.progress = false;
            state.success.status = true;
            const {data} = action.payload;
            state.user = data.user;
            state.isAuthenticated = true;
            localStorage.setItem('auth-token', data.accessToken)
            state.logout = false;
        })
        builder.addCase(Login.rejected, (state, action) => {
            state.progress = false;
            state.error.status = true;
            state.error.message = action.error.message;
        })
        builder.addCase(googleSignIn.pending, (state, action) => {
            state.progress = true;
            state.error.status = false;
            state.success.status = false;
        })
        builder.addCase(googleSignIn.fulfilled, (state, action) => {
            state.progress = false;
            state.success.status = true;
            const {data} = action.payload;
            state.user = data.user;
            state.isAuthenticated = true;
            localStorage.setItem('auth-token', data.accessToken)
            state.logout = false;
        })
        builder.addCase(googleSignIn.rejected, (state, action) => {
            const errorMessages = JSON.parse( action.error.message);
            state.progress = false;
            state.error.status = true;
       
            state.error.message = errorMessages.message[0].msg;
        })
        builder.addCase(Logout.fulfilled, (state, action) => {
            state.isAuthenticated = false;
        })
        builder.addCase(Logout.pending, (state, action) => {
            state.logout = true;
            state.user = {};
            state.isAuthenticated = false;
        })
        builder.addCase(UpdateAccount.fulfilled, (state, action) => {
            state.user = action.payload;
            state.accountUpdated = true;
            state.error.status = false;
        })
        builder.addCase(UpdateAccount.pending, (state, action) => {
            state.accountUpdated = false;
            state.error.status = false;
        })
        builder.addCase(UpdateAccount.rejected, (state, action) => {
            state.user = action.payload;
            state.accountUpdated = false;
            state.error.status = false;
        })
        builder.addCase(UpdateAccountPasword.fulfilled, (state, action) => {
            state.user = action.payload;
            state.resetModalStatus = false;
        })
        builder.addCase(UpdateAccountPasword.pending, (state, action) => {
            state.success.status = false;
            state.error.status = false;
        })
        builder.addCase(UpdateAccountPasword.rejected, (state, action) => {
            state.success.status = false;
            state.error.status = true;
        })
        builder.addCase(DeleteUserById.fulfilled, (state, action) => {
            state.success.status = false;
            state.error.status = false;
            state.accountDeleted = true;
        })
        builder.addCase(searchUsers.fulfilled, (state, action) => {
            state.searchResults = action.payload;
        })
        builder.addCase(ImageUpload.pending, (state, action) => {
            
        })
        builder.addCase(ImageUpload.fulfilled, (state, action) => {
            state.user = action.payload;
        })
        builder.addCase(ImageUpload.rejected, (state, action) => {
            
        })
        builder.addCase(UpdateUserWorkingType.fulfilled, (state, action) => {
            state.userAccount = action.payload;
            state.accountWorkingTypeUpdated = true;
        })
    }
});

export const userActions = usersSlice.actions;
export const userReducer = usersSlice.reducer;